import { AggregationAuthLink, BankConnection } from '../interfaces'
import { api } from '@utils/api/api'

export const getBankConnectionLink = (
  data: BankConnection,
): Promise<AggregationAuthLink> => {
  return api.post('/api/v1/banks/connect', data)
}
